
import { mapGetters } from 'vuex'
import promoData from '@/data/promo.json' // Changed from bannerData
export default {
  layout: 'Homepage',
  async asyncData({ $page, store, route }) {
    if ($page) return { page: $page }
    else return { page: await store.dispatch('pages/getPage', route.fullPath) }
  },
  data() {
    return {
      isVisible: false,
    };
  },
  head() {
    const title = this.page.seo.fullHead.child
      .map((el) => (el.tag === 'title' ? el.child[0].text : null))
      .filter((el) => el)[0]
    const metas = this.page.seo.fullHead.child.filter(
      (tag) => tag.node === 'element'
    )
    const metasArray = metas.filter((m) => m.tag === 'meta').map((m) => m.attr)
    const linkArray = metas.filter((m) => m.tag === 'link').map((m) => m.attr)
    const scriptArray = metas.filter((m) => m.tag === 'script')
    const meta = []
    const link = []
    const script = []

    if(process.env.ROBOTS === 'LIVE'){
      metasArray.push({name:'robots', content:'index, follow'})
    } else {
      metasArray.push({name:'robots', content:'noindex, nofollow'})
    }

    for (let i = 0; i < metasArray.length; i++) {
      const obj = {}
      if (metasArray[i].name) obj.name = metasArray[i].name
      if (metasArray[i].property) obj.property = metasArray[i].property
      obj.content =
        typeof metasArray[i].content === 'string'
          ? metasArray[i].content.replace(
              /(?<!\w-)\b\w+\.tefl\.org\b/g,
              'www.tefl.org'
            )
          : metasArray[i].content.join(' ')

      meta.push(obj)
    }
    for (let i = 0; i < linkArray.length; i++) {
      const obj = {}
      obj.rel = linkArray[i].rel
      obj.href = linkArray[i].href.replace(
        /(?<!\w-)\b\w+\.tefl\.org\b/g,
        'www.tefl.org'
      )

      link.push(obj)
      link.push({rel:"alternate",hreflang:'en',href:"https://www.tefl.org/"})
      link.push({rel:"alternate",hreflang:'x-default',href:"https://www.tefl.org/"})
      link.push({rel:"alternate",hreflang:'en-US',href:"https://www.tefl.org/en-us/"})
      link.push({rel:"alternate",hreflang:'en-IE',href:"https://www.tefl.org/ie/"})
      link.push({rel:"alternate",hreflang:'en-AU',href:"https://www.tefl.org/au/"})
      link.push({rel:"alternate",hreflang:'en-CA',href:"https://www.tefl.org/ca/"})
      link.push({rel:"alternate",hreflang:'en-ZA',href:"https://www.tefl.org/za/"})
    }
    for (let i = 0; i < scriptArray.length; i++) {
      const obj = {}
      obj.class = scriptArray[i].attr.class
      obj.type = scriptArray[i].attr.type
      let schemaText = scriptArray[i].child[0].text
        .replace(/(?<!\w-)\b\w+\.tefl\.org\b/g, 'www.tefl.org')
        .replace('"name":""', '"name":"Home"')

      // Remove empty BreadcrumbList injected by Yoast (causes GSC "Missing field itemListElement" error)
      try {
        const schema = JSON.parse(schemaText)
        if (Array.isArray(schema['@graph'])) {
          schema['@graph'] = schema['@graph'].filter(
            (item) =>
              !(
                item['@type'] === 'BreadcrumbList' &&
                (!item.itemListElement || item.itemListElement.length === 0)
              )
          )
          schemaText = JSON.stringify(schema)
        }
      } catch (e) {}

      obj.innerHTML = schemaText
      script.push(obj)
    }
    return {
      /* eslint-disable */
      title: title,
      meta: meta,
      link: link,
      script: script,
      __dangerouslyDisableSanitizers: ['script'],
      /* eslint-enable */
    }
  },
  computed: {
    ...mapGetters({
      detectedRegion: 'geolocation/region',
      userRegion: 'user/region',
    }),

    normalizedRegion() {
      const regionCode = this.userRegion && this.userRegion !== 'default'
                       ? this.userRegion
                       : this.detectedRegion;
      return regionCode;
    },


    promoRegionData() {
        if (!promoData || !Array.isArray(promoData.regions)) {
            return { specialOffer: {} }; // Return a safe empty structure
        }

        // Find the region matching the normalized region code
        let foundRegion = promoData.regions.find(r => r.code === this.normalizedRegion);

        // Fallback to 'en' if the specific region (even after normalization) is not found.
        if (!foundRegion) {
            foundRegion = promoData.regions.find(r => r.code === 'en');
        }

        return foundRegion || { specialOffer: {} }; // Always return an object with specialOffer
    },


    bfSliderEnabled() {
        const specialOffer = this.promoRegionData.specialOffer;
        return specialOffer && specialOffer.enabled && specialOffer.bfSlider === true;
    }
  },
  mounted(){
    // const query = window.location.search;
    // if(this.detectedRegion === 'en-us')
    // window.location.pathname = '/en-us/';
  }
}
